import { api } from "../axios";
import { SWPPlan, SwpTransactionOrderPayload } from "../../types";

export const fetchSwpDataById = (
  investmentAccountGuid: string,
  swpId: string
): Promise<SWPPlan> => {
  return api.get(`swp/${swpId}/`, {
    params: { investment_account_guid: investmentAccountGuid },
  });
};

export const createSwpTransaction = (payload: SwpTransactionOrderPayload) => {
  return api.post("swp/", payload);
};

export const deleteSwpTransactionApi = ({
  id,
  investment_account_guid,
}: {
  investment_account_guid: string;
  id: number;
}) => {
  return api.delete(`swp/${id}/`, {
    data: {
      investment_account_guid,
    },
  });
};

export const updateSwpTransactionApi = ({
  id,
  ...payload
}: SwpTransactionOrderPayload & { id: number }) => {
  return api.put(`swp/${id}/`, payload);
};

interface SwpStatsResponse {
  total_active_swp_amount: string;
  frequencies: string[];
  active_swp_count: number;
  next_installment_date: string | null;
  total_withdrawn_amount: string | null;
}

export const getSwpStats = (
  investmentAccountId: string
): Promise<SwpStatsResponse> => {
  return api.get(`swp/stats/`, {
    params: { investment_account_id: investmentAccountId },
  });
};
